import { gql } from "@apollo/client";

export default gql`
  mutation BackfillSlackDataMutation(
    $organizationId: Int!
    $startDate: String!
  ) {
    backfillSlackData(organizationId: $organizationId, startDate: $startDate) {
      organization {
        id
        slackIndexingConfiguration {
          indexNewChannelsByDefault
          indexMessages
          channels {
            id
            name
            shouldIndex
            lastIndexedTs
            firstIndexedTs
          }
        }
      }
    }
  }
`;
